/* Skin Notes: filter pills, "Show more", and links that jump to the footer email field.
   Works with sections/sc-skin-notes-blog.liquid and sections/sc-skin-note-article.liquid.
   Without JavaScript the page still works: every note shows and the pills are normal links. */
(function () {
  'use strict';

  /* ---- 1. "Get it by email" links: scroll to the footer signup and focus its field */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-sn-footer-email]');
    if (!link) return;
    var input = document.querySelector('.sc-footer__subscribe-input') ||
                document.querySelector('footer input[type="email"]');
    if (!input) return;
    event.preventDefault();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function () {
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    }, 500);
  });

  /* ---- 2. Index board: filters refill the board in place, Show more reveals the next batch */
  var board = document.querySelector('[data-sn-board]');
  if (!board) return;

  var items = Array.prototype.slice.call(board.querySelectorAll('[data-sn-item]'));
  var soon = board.querySelector('[data-sn-soon]');
  var more = board.querySelector('[data-sn-more]');
  var moreButton = more ? more.querySelector('button') : null;
  var pills = Array.prototype.slice.call(board.querySelectorAll('[data-sn-filter]'));
  var allLoaded = board.getAttribute('data-sn-all') === 'true';
  var mobile = window.matchMedia('(max-width: 749px)');

  var state = { tag: board.getAttribute('data-sn-current') || '', shown: 0 };

  function pageSize() { return mobile.matches ? 6 : 12; }

  function matches(item) {
    if (!state.tag) return true;
    var tags = ' ' + (item.getAttribute('data-tags') || '') + ' ';
    return tags.indexOf(' ' + state.tag + ' ') !== -1;
  }

  function render() {
    var list = items.filter(matches);
    items.forEach(function (item) { item.hidden = true; });
    list.slice(0, state.shown).forEach(function (item) { item.hidden = false; });
    if (soon) soon.hidden = !!state.tag;
    if (more) more.hidden = list.length <= state.shown;
    pills.forEach(function (pill) {
      var active = (pill.getAttribute('data-sn-filter') || '') === state.tag;
      pill.classList.toggle('is-active', active);
      if (active) { pill.setAttribute('aria-current', 'page'); } else { pill.removeAttribute('aria-current'); }
    });
  }

  function reset() {
    state.shown = pageSize();
    render();
  }

  pills.forEach(function (pill) {
    pill.addEventListener('click', function (event) {
      // On a tagged URL only that tag's notes were loaded, so let the link do a normal page load.
      if (!allLoaded) return;
      event.preventDefault();
      state.tag = pill.getAttribute('data-sn-filter') || '';
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', pill.getAttribute('href'));
      }
      reset();
    });
  });

  if (moreButton) {
    moreButton.addEventListener('click', function () {
      var before = state.shown;
      state.shown += pageSize();
      render();
      var firstNew = items.filter(matches)[before];
      var link = firstNew && firstNew.querySelector('a');
      if (link) link.focus({ preventScroll: true });
    });
  }

  var onResize = function () {
    if (state.shown < pageSize()) state.shown = pageSize();
    render();
  };
  if (mobile.addEventListener) { mobile.addEventListener('change', onResize); } else if (mobile.addListener) { mobile.addListener(onResize); }

  reset();
})();
